import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";

import { logout } from "../../store/actions";
import { SigninResponse, State } from "../../interfaces";
import { useSession } from "../../components/Hooks/UserHooks";

const LogoutPageComponent = (props: any) => {
  const dispatch = useDispatch();
  const { session } = useSession();

  const { success, loading } = useSelector(
    (state: any): State<any> => state.auth.logout
  );

  useEffect(() => {
    if (session && session.refreshToken && !loading) {
      dispatch(
        logout(
          { refreshToken: (session as SigninResponse)?.refreshToken },
          props.location.history
        )
      );
    }
  }, []);

  if (success) {
    return <Redirect to="/login" />;
  }

  return <></>;
};

export const LogoutPage = withRouter(LogoutPageComponent);
